<template>
    <div class="space-y-5">
        <section class="acc-glass rounded-2xl border border-white/10 p-5 sm:p-6">
            <div class="flex flex-col items-center gap-4 text-center sm:flex-row sm:text-left">
                <user-avatar
                    :src="profile && profile.avatar ? profile.avatar : ''"
                    :name="profile && profile.name ? profile.name : ''"
                    alt="Аватар користувача"
                    size="hero"
                    loading="eager"
                    class="shrink-0 bg-foxy-surface"
                />
                <div class="min-w-0">
                    <h1 class="break-words text-2xl font-extrabold">{{ profile && profile.name ? profile.name : 'Користувач' }}</h1>
                    <div class="mt-1 text-sm text-white/65">@{{ profile && profile.username ? profile.username : 'guest' }}</div>
                    <p class="mt-3 max-w-2xl text-sm text-white/75">Цей користувач обмежив доступ до особистих розділів профілю.</p>
                </div>
            </div>
        </section>

        <section class="grid grid-cols-1 gap-4 lg:grid-cols-2">
            <div class="acc-glass rounded-2xl border border-white/10 p-5">
                <h2 class="text-base font-extrabold">Книги</h2>
                <p class="mt-1 text-xs text-white/60">Загальний читацький відбиток користувача у FOXY.</p>
                <dl class="mt-4 grid grid-cols-2 gap-2 text-sm sm:grid-cols-3">
                    <div v-for="item in readingSummary" :key="item.key" class="rounded-xl border border-white/10 bg-white/5 p-3">
                        <dt class="text-xs text-white/60">{{ item.label }}</dt>
                        <dd class="mt-1 text-xl font-extrabold">{{ item.value }}</dd>
                    </div>
                </dl>
            </div>

            <div class="acc-glass rounded-2xl border border-white/10 p-5">
                <h2 class="text-base font-extrabold">Публікації та добірки</h2>
                <p class="mt-1 text-xs text-white/60">Опублікований користувачем вміст залишається доступним.</p>
                <div class="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                    <component
                        :is="item.href ? 'a' : 'div'"
                        v-for="item in contributionSummary"
                        :key="item.key"
                        :href="item.href || undefined"
                        class="flex items-center justify-between rounded-xl border border-white/10 bg-white/5 px-3 py-3 text-sm transition hover:border-foxy-action/40 hover:bg-white/10"
                    >
                        <span>{{ item.label }}</span>
                        <span class="font-extrabold">{{ item.value }}</span>
                    </component>
                </div>
            </div>
        </section>
    </div>
</template>

<script lang="js">
export default {
    name: 'RestrictedProfileOverview',
    props: {
        profile: { type: Object, default: null },
        dashboard: { type: Object, default: null },
    },
    computed: {
        stats() {
            return this.dashboard?.stats || {};
        },
        readingSummary() {
            return [
                { key: 'total', label: 'Усього книг', value: Number(this.stats.total_books_count || 0) },
                { key: 'read', label: 'Прочитано', value: Number(this.stats.read_count || 0) },
                { key: 'reading', label: 'Читає', value: Number(this.stats.reading_count || 0) },
                { key: 'planned', label: 'Заплановано', value: Number(this.stats.planned_count || 0) },
                { key: 'dropped', label: 'Не дочитано', value: Number(this.stats.dropped_count || 0) },
            ];
        },
        contributionSummary() {
            const username = encodeURIComponent(this.profile?.username || '');
            return [
                { key: 'reviews', label: 'Рецензії', value: Number(this.stats.reviews_count || 0), href: `/account/u/${username}/reviews` },
                {
                    key: 'discussions',
                    label: 'Дискусії',
                    value: Number(this.stats.discussions_count || 0),
                    href: '/discussions',
                },
                {
                    key: 'quotes-facts',
                    label: 'Цитати й факти',
                    value: Number(this.stats.quotes_count || 0) + Number(this.stats.facts_count || 0),
                    href: null,
                },
                {
                    key: 'collections',
                    label: 'Добірки',
                    value: Number(this.stats.collections_count || 0),
                    href: `/libraries?user=${username}`,
                },
            ];
        },
    },
};
</script>
